import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Button, Grid } from '@mui/material';
import OverrideRequestExplorer from "../../components/organisms/overrideRequestsExplorer/OverrideRequestsExplorer";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    label?: String;
}

const tabs: TabPanelProps[] = [
    {
        index: 0,
        value: 0,
        label: "Action Required",
    },
    {
        index: 1,
        value: 1,
        label: "All Requests",
    }
];


const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}


const MyApprovals = () => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <>
            <Grid container direction="row" justifyContent="left" alignItems="left">
                <Grid item xs={6}>
                    <Box display="flex" justifyContent="flex-start">
                        <h1 style={{ textAlign: "left" }}>My Override Approvals</h1>
                    </Box>
                </Grid>
            </Grid>
            <Box sx={{ width: '100%', background: "#fefefe", borderRadius: "10px" }}>

                <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 1 }}>
                    <Tabs value={value} onChange={handleChange} aria-label="resource explorer">
                        {tabs.map((item) => (
                            <Tab key={item.index} label={item.label} style={{ fontWeight: "bold", padding: "20px 30px" }} />
                        ))}
                    </Tabs>
                </Box>

                <TabPanel value={value} index={0}>
                    <OverrideRequestExplorer myApprovals={true} myActions={true}/>
                </TabPanel>

                <TabPanel value={value} index={1}>
                    <OverrideRequestExplorer myApprovals={true}/>
                </TabPanel>
            </Box>
        </>
    );
};

export default MyApprovals;